import Alpine from 'alpinejs';

window.Alpine = Alpine;

export default {
  init() {
    // JavaScript to be fired on all pages
    console.log('👋🏻 from common.ts');

    Alpine.start();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
